import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Button, message } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { adminAuth, getAdminToken, saveAdminAuth } from '../../api';

function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (getAdminToken()) {
      navigate('/dindoor', { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      const response = await adminAuth.login(values);
      saveAdminAuth(response.data.data);
      message.success('登录成功');
      navigate('/dindoor', { replace: true });
    } catch (err) {
      message.error(err.response?.data?.message || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
      background: 'linear-gradient(135deg, #101828 0%, #1d2939 100%)'
    }}>
      <Card style={{ width: 420, borderRadius: 18 }}>
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: '#101828' }}>后台登录</div>
          <div style={{ marginTop: 8, color: '#667085' }}>登录后进入瑞华海报管理后台。</div>
        </div>

        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="username"
            label="管理员账号"
            rules={[{ required: true, message: '请输入管理员账号' }]}
          >
            <Input prefix={<UserOutlined />} autoComplete="username" />
          </Form.Item>

          <Form.Item
            name="password"
            label="登录密码"
            rules={[{ required: true, message: '请输入登录密码' }]}
          >
            <Input.Password prefix={<LockOutlined />} autoComplete="current-password" />
          </Form.Item>

          <Button type="primary" htmlType="submit" block loading={loading} size="large">
            登录后台
          </Button>
        </Form>
      </Card>
    </div>
  );
}

export default Login;
